import Events from '@/events/events'
import { EVENTS } from '../constants/commons'
import sendBugAlert from '../errors/sendBugAlert'

class Copy {
  static toClipboard(text, successMessage, errorMessage) {
    copyToClipboard(
      text,
      () => {
        if (!successMessage) return
        Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
          title: successMessage,
          body: text,
          type: 'success',
        })
      },
      error => {
        if (!errorMessage) return
        Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
          title: successMessage,
          body: text,
          type: 'error',
        })
        sendBugAlert(error)
      },
    )
  }
}

function copyToClipboard(text, onSuccess = () => {}, onFailed = err => {}) {
  let isClient = false
  try {
    if (window) isClient = true
  } catch (error) {
    console.log(error)
  }
  if (!isClient) {
    onFailed && onFailed(new Error('Is not client'))
    return
  }
  try {
    const type = 'text/plain'
    const blob = new Blob([text], { type })
    const data = [new ClipboardItem({ [type]: blob })]
    navigator.clipboard.write(data)
    onSuccess && onSuccess()
  } catch (error) {
    console.log('🚀 ~ Copy ~ copyToClipboard ~ error:', error)
    onFailed && onFailed(error)
  }
}

export default Copy
